<div class="container">
  <div class="video-container container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <app-button *ngIf="!isCaptured" [title]="'Switch Camera' | translate" (click)="onChangeCamera()"
          [buttonCssClass]="'button button-right button-black'">
        </app-button>
        <video [class.show]="!isCaptured" [class.hide]="isCaptured" #video id="video" [width]="WIDTH" [height]="HEIGHT"
          autoplay></video>
        <canvas [class.show]="isCaptured" [class.hide]="!isCaptured" #canvas id="canvas" [width]="WIDTH"
          [height]="HEIGHT"></canvas>
      </div>
    </div>
  </div>

  <div class="camera-buttons-container">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <app-button *ngIf="!isCaptured" [title]="'Take Photo' | translate" (click)="capture()"
            [buttonCssClass]="'button button-right button-black'">
          </app-button>
          <app-button *ngIf="isCaptured" [title]="'Take Another Photo' | translate" (click)="reCapture()"
            [buttonCssClass]="'button button-right button-black'">
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>
